import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { addToCart, setIsBuyNow, setShowAlert } from '@app/actions/shoppingmall/cart.action';
import { actionSetWishYN } from '@app/actions/shoppingmall/product-wishlist.action';
import { clearWAlert, setWAlert } from '@app/actions/w-alert.action';
import { ActionConstant } from '@app/common/constant/action-constant';
import { CommonConstant } from '@app/common/constant/common.constant';
import { MessageConstant } from '@app/common/constant/message.constant';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { AuthUtil } from '@app/common/util/auth.util';
import { CartUtil } from '@app/common/util/cart.util';
import { CommonUtils } from '@app/common/util/common.util';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { WAlertStatus } from '@app/models/components/w-alert-stauts.model';
import { OrderMstModel } from '@app/models/myoffice/order/order-mst.model';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { SmPayHeaderModel } from '@app/models/system/sm-pay-header.model';
import { SmWownetPgModel } from '@app/models/system/sm-wownet-pg.model';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { WownetWordModel } from '@app/models/system/wownet-word.model';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { CartState } from '@app/selectors/shoppingmall/cart.selector';
import { getWishlist, PdtWishListState } from '@app/selectors/shoppingmall/product-wishlist.selector';
import { getFindPayHeader, getSmWownet, getSmWownetPg, getWowWord, SmWownetState } from '@app/selectors/system/sm-wownet.selector';
import { getWAlertStatus, WAlertState } from '@app/selectors/w-alert.selector';
import { ProductWishlistService } from '@app/services/shoppingmall/product-wishlist.service';
import { ProductService } from '@app/services/shoppingmall/product.service';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
    selector: '[product]',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
    @Input()
    product: OrdPdtModel = {} as OrdPdtModel;

    @Input()
    kind: string = '';

    @Input()
    typeTemplate: string = '';

    @Input()
    number: number = 0;

    smPayHeader$ = new Observable<SmPayHeaderModel>();

    smWowWord$ = new Observable<WownetWordModel>();
    smWowWord: any = {} as WownetWordModel;

    smWownet$ = new Observable<SmWownetModel>();
    smWownet: any = {} as SmWownetModel;

    smWownetPg$ = new Observable<SmWownetPgModel>();
    smWownetPg: any = {} as SmWownetPgModel;

    cartInfo$ = new Observable<OrderMstModel[]>();
    cartInfo: OrderMstModel[] = {} as OrderMstModel[];

    productWishYN: Map<string, string> = new Map();
    productWishYN$ = new Observable<Map<string, string>>();

    wAlertStatus$ = new Observable<WAlertStatus>();

    wishYN: string = '';
    urlWownet: string = CommonConstant.URL_WOWNET;

    pointRate: number = 0;
    isLogin: boolean = AuthUtil.isLogined();
    isPv1: boolean = false;
    isPv2: boolean = false;
    isPv3: boolean = false;
    isRetailAmt: boolean = false;
    isAmt: boolean = false;
    isOrd: boolean = false;
    isPoint: boolean = false;
    isConsumer: boolean = false;
    isLinkGuest: boolean = false;
    isLinkCart: boolean = false;
    lang: string = CommonUtils.getLang();
    userKindCd: string = "";

    constructor(
        private _router: Router,
        private _overlayLoadingStore: Store<OverlayLoadingState>,
        private _wAlertStore: Store<WAlertState>,
        private _cartStore: Store<CartState>,
        private _smWownetStateStore: Store<SmWownetState>,
        private _productService: ProductService,
        private _translateService: TranslateService,
        private _productWishlistService: ProductWishlistService,
        private _wishListStore: Store<PdtWishListState>,
    ) {
        this.smPayHeader$ = this._smWownetStateStore.select(getFindPayHeader);
        this.smWowWord$ = this._smWownetStateStore.select(getWowWord);
        this.smWownet$ = this._smWownetStateStore.select(getSmWownet);
        this.smWownetPg$ = this._smWownetStateStore.select(getSmWownetPg);
        this.productWishYN$ = this._wishListStore.select(getWishlist);
        this.wAlertStatus$ = this._wAlertStore.select(getWAlertStatus);
    }

    ngOnInit(): void {
        this.wishYN = ConvertUtil.convertToString(this.product.wishYN);

        let loginedInfo = AuthUtil.getLoginedInfo();
        if (loginedInfo) {
        this.userKindCd = ConvertUtil.convertToSring(loginedInfo.userKindCd);
        }

        this.initData(
            this.smPayHeader$,
            this.smWowWord$,
            this.smWownet$,
            this.smWownetPg$
        );
        this.cartInfo$.subscribe(res => this.cartInfo = res);

        this.productWishYN$.subscribe((res) => {
            if (res.size > 0) {
                for (const [key, value] of res) {
                    if (key == ConvertUtil.convertToString(this.product.pdtCD)) {
                        this.wishYN = value;
                    }
                }
            }
        });

        this.wAlertStatus$.subscribe(res => this.handleActionConfirm(res));
    }

    onClickProductDetail(item: OrdPdtModel): void {
        this._productService.getItemOfProduct(item, this.smWownet.lshowPdtYn);
    }


    onAddToCart(event: any): void {
        if (this.isLogin) {
            let item = this.product;
            let quantity = 1;
            let pdtCd = ConvertUtil.convertToString(item.pdtCD);
            let kindCd = ConvertUtil.convertToString(item.cateNameOrg);

            if (Number(item.amt) <= 0 || (this.userKindCd == 'U00' && Number(item.retailAmt) <= 0)) {
                this.showAlertPriceInvalid();
                return;
            }

            if (quantity > 0) {
                let params = CartUtil.getParamsAddToCart(pdtCd, quantity, kindCd);

                this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
                this._cartStore.dispatch(setShowAlert({ show: true }));
                this._cartStore.dispatch(setIsBuyNow({ isBuyNow: false }));
                this._cartStore.dispatch(addToCart({ params: params }));
            } else {
                this.showAlertRequiredQuantityInvalid();
            }
        } else {
            this.showAlertRequiredLogin();
        }

        event.stopPropagation();
    }

    onClickWishList(event: any): void {
        this.wishYN = this._productWishlistService.addWishList(
            ConvertUtil.convertToString(this.product.pdtCD),
            this.wishYN
        );

        this._wishListStore.dispatch(
            actionSetWishYN({
                pdtCd: ConvertUtil.convertToString(this.product.pdtCD),
                wishYn: this.wishYN,
            })
        );
        event.stopPropagation();
    }

    private handleActionConfirm(status: WAlertStatus): void {
        if (status.action === ActionConstant.ACTION_CONFIRM_LOGIN && status.isConfirm) {
            this._wAlertStore.dispatch(clearWAlert());
            this._router.navigate(["/login"]);
        }
    }

    private showAlertRequiredLogin(): void {
        this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.confirm, message: this._translateService.instant("msg.purchase.required.login"), action: ActionConstant.ACTION_CONFIRM_LOGIN } }));
    }

    private showAlertRequiredQuantityInvalid(): void {
        this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message: MessageConstant.msgQuantityInvalid } }));
    }

    private showAlertPriceInvalid(): void {
        this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message: MessageConstant.msgPriceInvalid } }));
    }

    private initData(
        smPayHeader$: Observable<SmPayHeaderModel>,
        smWowWord$: Observable<WownetWordModel>,
        smWownet$: Observable<SmWownetModel>,
        smWownetPg$: Observable<SmWownetPgModel>
    ) {
        smPayHeader$.subscribe((res) => {
            if (ValidationUtil.isNotNullAndNotEmpty(res)) {
                this.isPv1 = CommonUtils.getYN(
                    ConvertUtil.convertToString(res.pv1)
                );
                this.isPv2 = CommonUtils.getYN(
                    ConvertUtil.convertToString(res.pv2)
                );
                this.isPv3 = CommonUtils.getYN(
                    ConvertUtil.convertToString(res.pv3)
                );
            }
        });

        smWownet$.subscribe((res) => {
            if (ValidationUtil.isNotNullAndNotEmpty(res)) {
                this.smWownet = res;
                this.isAmt = res.lShowAmtYn === CommonConstant.YES;
                this.isRetailAmt = res.lShowRetailYn === CommonConstant.YES;
                this.isOrd = res.lOrdYn === CommonConstant.YES;
            }
        });

        smWowWord$.subscribe((res) => {
            if (ValidationUtil.isNotNullAndNotEmpty(res)) {
                this.smWowWord = res;
            }
        });

        smWownetPg$.subscribe(
            (res) => (this.isPoint = res.settMPoint === CommonConstant.YES)
        );
    }
}
